import React from 'react';
import { useLocation, useNavigate } from '../nav';
import { VeeMascot } from '../components/VeeMascot';
import { CustomIcon } from '../components/CustomIcons';
import { paymentQuery, readPayment } from '../lib/transfer';
export function Draft() {
  const navigate = useNavigate();
  const {
    pathname,
    search
  } = useLocation();
  const payment = readPayment(pathname + search);
  const query = payment.isBill ? `bill=${encodeURIComponent(payment.bill || '')}` : paymentQuery(payment);
  return <main className="flex h-full w-full flex-col bg-brand-cloud" data-id="element-331" data-mp="2azw60knpc61t">
      <header className="flex items-center gap-3 bg-white px-5 pb-4 pt-14" data-id="element-332" data-mp="2b28t1c8bh6lq">
        <button onClick={() => navigate(-1)} aria-label="Go back" className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand-cloud text-brand-navy" data-id="element-333" data-mp="2fzs648ta3dc3">←</button>
        <div data-id="element-334" data-mp="llzjrepxvtmo">
          <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-brand-cobalt" data-id="element-335" data-mp="lmj4f36z4w4e">Prepared payment</p>
          <h1 className="mt-1 text-lg font-extrabold tracking-tight text-brand-navy" data-id="element-336" data-mp="qkkpturvh7j1">{payment.title}</h1>
        </div>
      </header>

      <section className="phone-scroll flex-1 overflow-y-auto px-5 py-5" data-id="element-337" data-mp="10hcr6gdx7m87">
        <div className="flex items-center gap-3 rounded-[22px] bg-[#10294a] p-4 text-white" data-id="element-338" data-mp="10f9pgz3eo4nn">
          <VeeMascot size={44} state="speaking" decorative data-id="element-339" data-mp="vije2p2jpx8k" />
          <p className="text-xs leading-relaxed text-blue-100" data-id="element-340" data-mp="qk8145gyf6m4"><strong className="text-white" data-id="element-341" data-mp="qhc1mcpgk9vk">This draft is prepared, not sent.</strong> Review the complete details below.</p>
        </div>

        <article className="relative mt-5 overflow-hidden rounded-[30px] bg-white p-5 shadow-float" data-id="element-342" data-mp="1j7koghuxvigh">
          <div className="flex items-center gap-4 border-b border-slate-100 pb-5" data-id="element-343" data-mp="1e7zqa9nlfe4t">
            <span className="flex h-14 w-14 items-center justify-center rounded-[18px] bg-brand-cloud text-brand-cobalt" data-id="element-344" data-mp="1a7fpmw3t9sdx"><CustomIcon name={payment.icon} size={26} data-id="element-345" data-mp="2u3zu4r8niya" /></span>
            <div className="min-w-0" data-id="element-346" data-mp="2r9du8sktq2r">
              <p className="text-[11px] font-bold uppercase tracking-[.14em] text-brand-slate" data-id="element-347" data-mp="3ux561dk5xm8q">{payment.isBill ? 'Service' : 'Recipient'}</p>
              <h2 className="mt-1 truncate text-xl font-extrabold tracking-tight text-brand-navy" data-id="element-348" data-mp="9xtjqf5jgek">{payment.party}</h2>
              <p className="mt-1 text-xs font-semibold text-brand-slate" data-id="element-349" data-mp="55wq41amw4q2">{payment.bank} · {payment.account}</p>
            </div>
          </div>
          <div className="mt-5 grid grid-cols-2 gap-3" data-id="element-350" data-mp="3reo5wdkj3sfy">
            <Metric label="Source" value="VE Bank Account" data-id="element-351" data-mp="3rhaf0hn2ig0a" />
            <Metric label="Amount" value={`₦${payment.amount}`} strong data-id="element-352" data-mp="3dnar1cxkfir9" />
            <Metric label="Fee" value="₦0.00" data-id="element-353" data-mp="3if13ppjz6ilu" />
            <Metric label="Total debit" value={`₦${payment.amount}`} strong data-id="element-354" data-mp="3ig3wy44rsx4x" />
          </div>
          <div className="mt-5 border-t border-slate-100 pt-4" data-id="element-355" data-mp="33rptps3fz6nu">
            <p className="text-[10px] font-extrabold uppercase tracking-[.14em] text-brand-slate" data-id="element-356" data-mp="38o6dyb7it0vn">Narration</p>
            <p className="mt-1 text-sm font-bold text-brand-navy" data-id="element-357" data-mp="2uqhv18x0k3t8">{payment.narration}</p>
          </div>
        </article>

        {!payment.isBill && <button onClick={() => navigate('/transfer')} className="mt-4 min-h-[48px] w-full rounded-2xl bg-white text-sm font-extrabold text-brand-cobalt shadow-soft" data-id="element-358" data-mp="2g2hwtlo6b92l">
            Edit recipient or amount
          </button>}

        <aside className="mt-4 flex gap-3 rounded-[22px] border border-orange-100 bg-orange-50 p-4" data-id="element-359" data-mp="2p48ymfflevr6">
          <span className="mt-0.5 font-extrabold text-brand-orange" aria-hidden="true" data-id="element-360" data-mp="2k31pabxsxoie">!</span>
          <p className="text-xs leading-relaxed text-brand-slate" data-id="element-361" data-mp="2z0bzlhypkocj">If you continue, the account above will be reviewed for a <strong className="text-brand-navy" data-id="element-362" data-mp="2u1hkor3v3jxp">₦{payment.amount}</strong> debit. You can still go back.</p>
        </aside>
      </section>

      <footer className="border-t border-slate-200 bg-white p-5" data-id="element-363" data-mp="37via2u8xbule">
        <button onClick={() => navigate(`/review?${query}`)} className="flex min-h-[54px] w-full items-center justify-between rounded-2xl bg-brand-cobalt px-5 text-sm font-extrabold text-white" data-id="element-364" data-mp="33slxpl9z8upw">
          Continue to review <span aria-hidden="true" data-id="element-365" data-mp="3culf4eowm0td">→</span>
        </button>
      </footer>
    </main>;
}
function Metric({
  label,
  value,
  strong = false
}: {
  label: string;
  value: string;
  strong?: boolean;
}) {
  return <div className="rounded-2xl bg-brand-cloud p-3" data-id="element-366" data-mp="4oznwb2l0nkl">
      <p className="text-[9px] font-extrabold uppercase tracking-[.12em] text-brand-slate" data-id="element-367" data-mp="9hj0p5tg3eoc">{label}</p>
      <p className={`mt-1 text-xs tabular-nums ${strong ? 'font-extrabold text-brand-navy' : 'font-bold text-brand-slate'}`} data-id="element-368" data-mp="efua5fftvn61">{value}</p>
    </div>;
}